import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../../shared/services/session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiResponse } from '../../../shared/models/api-response';
import { StateService } from '../../../shared/services/state.service';
import { StudentService } from '../student.service';
import { StudentInfo } from '../student.models';
import * as $ from "jquery";

@Component({
  selector: 'app-inloggning',
  templateUrl: './inloggning.component.html',
  styleUrls: ['./inloggning.component.scss']
})
export class InloggningComponent implements OnInit {

  public bloburl: string;
  public mydevice: string = "";
  licenseId: string;
  student: StudentInfo;
  errorMessage: string;
  loading: boolean = true;
  saved: boolean = false;


  constructor(private route: ActivatedRoute,
    private userService: StudentService,
    private router: Router,
    private sessionService: SessionService,
    private stateService: StateService) {
  }

  async ngAfterViewInit() {
    await this.loadScript('../../../../assets/yr3-commonjs/scripts/jquery-3.5.1.min.js');
    await this.loadScript('../../../../assets/yr3-commonjs/scripts/jqueryui.min.js');

  }

  private loadScript(scriptUrl: string) {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script');
      scriptElement.src = scriptUrl;
      scriptElement.onload = resolve;
      document.body.appendChild(scriptElement);
    })
  }
  ngOnInit() {
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var userAgent = navigator.userAgent.toLowerCase();
    var android_dev = userAgent.indexOf("android") > -1;
    var chrome_browser = userAgent.indexOf("chrome") > -1;
    var samsung_browser = userAgent.indexOf("samsung") > -1;
    if (isIOS) {
      this.mydevice = "ipad";
    }
    else if (android_dev) {
      this.mydevice = "android";

      if (samsung_browser) {
        this.mydevice = this.mydevice + "_samsung";
      }
      else if (chrome_browser) {
        this.mydevice = this.mydevice + "_chrome";

      }
      var body = document.body;
      body.classList.add(this.mydevice);
    }
    this.bloburl = this.sessionService.bloburl;
    this.licenseId = this.stateService.getLicenseId();
    if (!this.licenseId) {
      this.errorMessage = "Saknar licenseId"
    } else {
      
      this.getstudent(this.licenseId);

    }

    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
      if (ua.indexOf('chrome') > -1) {

      } else {
        $("body").addClass("mac");
      }
    }

   


  }


  private showStudentColor() {
    var colorcodeelement = <HTMLInputElement>document.getElementById("colorcode");
    colorcodeelement.setAttribute("style", "opacity:1");

    switch (this.student.colorId) {
      case "1ec762636a3b4278a38a4e3b662fc35e":
        colorcodeelement.setAttribute("style", "background-color:#FC9896");
        break;
      case "37991529a72e44eca81fcd4bed5c509a":
        colorcodeelement.setAttribute("style", "background-color:#98BE72");
        break;
      case "4567c50645764b62ba15df77fa9e7d4b":
        colorcodeelement.setAttribute("style", "background-color:#F5C32C");
        break;
      case "14edcb57120e4054a37033db039565b3":
        colorcodeelement.setAttribute("style", "background-color:#AA9DCB");
        break;
      case "982a83555af141d4bc352967991c93f0":
        colorcodeelement.setAttribute("style", "background-color:#6EB7D8");
        break;
    }
    colorcodeelement.removeAttribute("disabled");
  }s



 




  getstudent(studentLicenseId: string): void {


    this.userService.getstudentno(studentLicenseId).subscribe((data: ApiResponse<StudentInfo>) => {

      if (data.success) {
        this.student = data.payload;
        this.showStudentColor();
      }
      else {
        this.errorMessage = `Fel vid hämtning av kapitel, fel: ${data.errorMessage}`;
      }
    });

    this.loading = false;
  }
}
